import { CMS_API } from '~/configs/api'
import { HttpRequestMethod } from '~/configs/enums'

import { useApi } from '~/composables/common/use-api'
import { useGames } from '~/composables/games/use-games'
import { useNavigate } from '~/composables/common/use-navigate'

import type { BannerItem } from '~/utils/interface'
import type { JackpotXocdia } from '~/stores/jackpot.store.ts'

export function useBanners() {
  const { request } = useApi()
  const { playGame } = useGames()
  const { isMobile } = useDevice()
  const { navigate } = useNavigate()
  const storeJackpot = useJackpotStore()
  const banners = ref<BannerItem[]>([])

  const jackpotXocdia = computed((): JackpotXocdia => {
    return storeJackpot.getXocDiaJackpot()
  })
  
  async function getBanners(): Promise<void> {
    try {
      const params = isMobile
        ? {
            mobile: true
          }
        : null

      const { data } = await useAsyncData(
        'banners',
        async () =>
          await request(CMS_API.BANNERS, {
            method: HttpRequestMethod.GET,
            params
          })
      )

      if (data?.value?.data) {
        banners.value = [...data.value.data]
      }
    } catch (e) {
      console.error('Failed to fetch banners', e)
    }
  }

  async function clickBannerSlide(item: BannerItem): Promise<void> {
    if (item.link) {
      void navigate(item.link, item?.loginRequired)
    } else {
      void playGame(item)
    }
  }
  return {
    clickBannerSlide,
    getBanners,
    banners,
    jackpotXocdia
  }
}